import './on-air.scss';

class OnAir {
    constructor(target) {
        this.element = $(target);

        this.settings = {
            jsonUrl: this.element[0].dataset.url,
            pageId: this.element[0].dataset.pageid,
            refreshInterval: 60500, // 1+ minute
            retryDelay: 1000, // 1 seconds
            maxRetries: 3,
        };

        if (this.element.data('refresh-interval')) {
            this.settings.refreshInterval = this.element.data('refresh-interval');
        }

        this.currentArtistElement = this.element.find('.on-air__current-artist');
        this.currentSongElement   = this.element.find('.on-air__current-song');
        this.nextShowElement      = this.element.find('.on-air__next-title');
        this.currentImageElement  = this.element.find('.on-air__image');
        this.nextImageElement     = this.element.find('.on-air__next-image');

        // Cache initialization
        this.cache = {
            content: null,
            lastFetch: 0,
        };

        // Polling interval reference
        this.pollingInterval = null;

        this.element[0].onAirInstance = this;

        this.init();
    }

    // Initialize the poller
    init() {
        this.startPolling();
    }

    // Start the polling mechanism
    startPolling() {
        // Initial fetch
        this.fetchAndUpdateData()
            .then((data) => {
                this.element.removeClass('is-loading');
                this.onDataUpdate(data);
            })
            .catch(this.onError);

        // Set up periodic polling
        this.pollingInterval = setInterval(() => {
            this.fetchAndUpdateData()
                .then(this.onDataUpdate.bind(this))
                .catch(this.onError);
        }, this.settings.refreshInterval);
    }

    // Stop polling
    stop() {
        if (this.pollingInterval) {
            clearInterval(this.pollingInterval);
            this.pollingInterval = null;
        }
    }

    async fetchAndUpdateData(retryCount = 0) {
        const now = Date.now();

        // Check cache freshness
        // if (this.cache.content && now - this.cache.lastFetch < this.settings.refreshInterval) {
        //     return this.cache.content;
        // }

        try {
            const parseURL = new URL(window.location.href);
            const response = await $.ajax({
                type: 'POST',
                url: window.ballers.ajaxPath + '?action=get_onair_data',
                data: {
                    currentPageID: this.settings.pageId,
                    onAirOnly: parseURL.searchParams.get('onAirOnly'),
                },
            });

            const data = response.data;

            // Update cache
            this.cache.content   = data;
            this.cache.lastFetch = now;

            return data;
        } catch (error) {
            console.error('Error fetching data:', error);

            if (retryCount < this.settings.maxRetries) {
                await new Promise((resolve) => setTimeout(resolve, this.settings.retryDelay));

                return this.fetchAndUpdateData(retryCount + 1);
            }

            throw error;
        }
    }

    // Default UI update method - can be overridden through options
    onDataUpdate(data) {
        this.currentArtistElement.html(data.currentArtist);
        this.currentSongElement.html(data.currentSong);
        this.nextShowElement.html(data.nextArtist);
        this.currentImageElement.replaceWith(data.currentShowImage);
        this.nextImageElement.replaceWith(data.nextShowImage);

        this.updateSliderScroller(data);
    }

    updateSliderScroller(data) {
        const scrollers = $(document.body).find('.js-slider-scroller');

        if (scrollers.length) {
            scrollers.each((index, element) => {
                element.sliderScrollerInstance.updateSlides(data);
            });
        }
    }

    // Default error handler - can be overridden through options
    onError(error) {
        console.error('Polling error:', error);
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const elements = document.querySelectorAll('.js-on-air');

    elements.forEach((element) => new OnAir(element));
});
